export default __webpack_public_path__ + "static/media/b12.c75a675e.jpg";